export const CANNOT_ADD_JOB = 'cannot-add-job';
export const ADD_EQUIPMENT_OPTION = 'add-equipment-option';
export const NO_EQUIPMENT_ADD_OPTION = 'no-equipment-add-option';
export const CUSTOMER_EQUIPMENT_OPTION = 'customer-equipment-option';
export const SEARCH_CUSTOMER_EQUIPMENT_INPUT =
  'search-customer-equipment-input';
export const JOB_LIST_TABLE = 'job-list-table';
export const NO_ITEMS_ADDED = 'no_items_added';
export const OPEN_SETTINGS_BUTTON = 'open-settings-button';
export const VIEW_ON_XERO = 'view-on-xero';
export const PAYMENT_STATUS = 'payment_status';
export const PURCHASE_ORDER = 'purchase_order';
export const FINALIZE_BUTTON = 'finalize-button';
export const CREATED_ON = 'created_on';
export const DOWNLOAD_DOCKET = 'download-docket';
export const PRINT_DOCKET = 'print-docket';
export const FINALIZED_ON = 'finalized_on';
export const STATUS_HEADING = 'status-heading';
export const MAIN_HEADING = 'main-heading';
export const CUSTOMER_CONACT_DETAILS = 'customer-contact-details';
export const CUSTOMER_ADDRESS = 'customer-address';
export const CUSTOMER_NAME = 'customer_name';
